/**
 * MouseHandler
 * マウスの座標を取得して、Uniformに渡す
 */

import * as THREE from 'three/webgpu';
import {
  uniform,
} from 'three/tsl';

export class MouseHandler {
  private canvas: HTMLCanvasElement;
  private width: number;
  private height: number;
  private mouseUniform: THREE.TSL.ShaderNodeObject<THREE.UniformNode<THREE.Vector2>>;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this.width = canvas.clientWidth;
    this.height = canvas.clientHeight;
    this.mouseUniform = uniform(new THREE.Vector2(this.width * 0.5, this.height * 0.5), 'vec2');

    this.canvas.addEventListener('pointermove', (event: PointerEvent) => {
      const rect = this.canvas.getBoundingClientRect();
      const scaleX = this.width / rect.width;
      const scaleY = this.height / rect.height;
      const x = (event.clientX - rect.left) * scaleX;
      const y = (event.clientY - rect.top) * scaleY;
      this.mouseUniform.value.set(x, this.height - y);
    });

  }

  public getMouseUniform(): THREE.TSL.ShaderNodeObject<THREE.UniformNode<THREE.Vector2>> {
    return this.mouseUniform;
  }
}